module.exports = __webpack_public_path__ + "images/shimo/board-list-f52904951f1e19bc8307bb3f3c3ec69b.png";